import './Fit.css';

const FOCUS_ITEMS = [
  {
    title: 'Sanierungs- & Renovierungsobjekte',
    text: 'Altbestand mit Substanz und Bestandsschutz in Lagen, die Neubau nicht mehr zulässt.',
  },
  {
    title: 'Villen, Landhäuser, Gutshöfe',
    text: 'Einfamilien-Bestand im oberen Segment mit baulichem Entwicklungs-Spielraum.',
  },
  {
    title: 'Lagen, in denen Fläche Mangelware ist',
    text: 'Hanggrundstücke, Seenähe, geschützte Ensembles, Innsbruck-Hügel, Wiener Cottage, Bodensee, Südtirol, Balearen.',
  },
  {
    title: 'Luxus-Qualität zum günstigen Einstieg',
    text: 'Der Wert schlummert in Lage und Substanz – nicht im Glanz. Sie kaufen den Rohdiamanten, nicht das fertige Produkt.',
  },
  {
    title: 'Grundstücke mit Reserve',
    text: 'Unterbebaute Parzellen in überteuerten Lagen, bei denen Aufstockung oder Ersatzneubau realistisch ist.',
  },
];

const OUT_ITEMS = [
  {
    title: 'Zinshäuser & Mehrfamilienhäuser',
    text: 'Cashflow-Optimierung ist ein anderes Geschäft. Dafür gibt es spezialisierte Asset-Manager.',
  },
  {
    title: 'Vorsorge- & Anlagewohnungen',
    text: 'Neubau-Wohnungen als Steuer-Vehikel laufen über Bauträger und Vertriebspartner, nicht über Pre Market Scouting.',
  },
  {
    title: 'Stadtkern-Apartments zur Vermietung',
    text: 'Klassische Kapitalanlagen in der Innenstadt sind im Exposé-Markt gut abgebildet – da braucht es uns nicht.',
  },
  {
    title: 'Fix & Flip im Massen-Segment',
    text: 'Kurze Haltedauern, hoher Umschlag, Volumen-Geschäft – passt nicht zu unserem 1:1-Mandat pro Zone.',
  },
  {
    title: 'Gewerbe, Büro, Retail, Hotel',
    text: 'Assetklassen mit eigener Logik, eigenen Gutachter-Kreisen und eigenem Zyklus. Nicht unser Spezialgebiet.',
  },
];

export default function Fit() {
  return (
    <section className="fit" id="fokus" aria-label="Unser Spielfeld – Investment-Fokus">
      <div className="container fit__inner">
        <header className="fit__head">
          <span className="eyebrow">
            <span className="eyebrow__dot" /> Unser Spielfeld
          </span>
          <h2 className="fit__title">
            Wir spezialisieren uns auf{' '}
            <span className="fit__title-accent">Substanz in Top-Lage</span> –
            dort, wo Neubau nicht mehr geht.
          </h2>
          <p className="fit__lead">
            Unser Mandat ist fokussiert. Wir finden Sanierungs- und
            Renovierungsobjekte in Lagen, in denen gute Flächen Mangelware sind
            und sich Luxus-Qualität nur noch über den Bestand erschließen lässt.
            Damit Sie wissen, worauf Sie sich einlassen – und worauf nicht.
          </p>
        </header>

        <div className="fit__grid">
          <article className="fit-block fit-block--focus">
            <div className="fit-block__head">
              <span className="fit-block__label fit-block__label--focus">
                Im Fokus
              </span>
              <h3 className="fit-block__heading">
                Objekte mit Substanz in knappen Lagen.
              </h3>
            </div>
            <ul className="fit-list">
              {FOCUS_ITEMS.map((item, i) => (
                <li key={i} className="fit-item">
                  <span className="fit-item__marker fit-item__marker--focus" aria-hidden="true" />
                  <div className="fit-item__body">
                    <strong>{item.title}</strong>
                    <span>{item.text}</span>
                  </div>
                </li>
              ))}
            </ul>
          </article>

          <article className="fit-block fit-block--out">
            <div className="fit-block__head">
              <span className="fit-block__label fit-block__label--out">
                Nicht unser Mandat
              </span>
              <h3 className="fit-block__heading">
                Cashflow-Produkte & Volumen-Geschäft.
              </h3>
            </div>
            <ul className="fit-list">
              {OUT_ITEMS.map((item, i) => (
                <li key={i} className="fit-item">
                  <span className="fit-item__marker fit-item__marker--out" aria-hidden="true" />
                  <div className="fit-item__body">
                    <strong>{item.title}</strong>
                    <span>{item.text}</span>
                  </div>
                </li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
